import { apiConstants } from '../../apiConstant'
import { serviceCall, serviceCallAuth } from '../../serviceCall'

const joinCall = (data, callback, errorCallBack) => {
  
  return async (dispatch) => {
    serviceCallAuth({
      url: apiConstants.JOIN.JOIN_CALL,
      method: 'post',
      data: data,
    })
      .then((response) => {
        callback && callback(response)
      })
      .catch((error) => {
        errorCallBack && errorCallBack(error.response)
      })
  }
}

export default joinCall
